export default {"src":"/_next/static/media/nginx.dd577355.svg","height":291,"width":256,"blurWidth":0,"blurHeight":0};